const Video = () => ({
  isPlaying: true,

  togglePlayback () {
    this.isPlaying = !this.isPlaying

    if (!this.isPlaying) {
      this.$refs.video.pause()
    } else {
      this.$refs.video.play()
    }
  }

})

export default Video
